import React from 'react';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faEye, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import ButtonBase from '@material-ui/core/ButtonBase';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { get, List, Map } from "immutable";

const useStyles = makeStyles((theme) => ({
    containerGrid: {
        //margin: "7px 0px"
    },
    buttonBase: {
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "13px 0px"
    },
    visibilityButtonContainer: {
        alignSelf: "center"
    },
    visibilityButton: {
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        padding: `13px 0px !important`
    }
}));
export default function DataSetItem(props) {
    const classes = useStyles();
    const handleUpdate = (index, dataList, setFunc) => {
        if (!props.isChild) {
            const clone = new Map(dataList).set(index, !dataList.get(index))
            var rObj = {};
            for (var [key, value] of clone.entries()) {
                rObj[key] = value;
            }
            setFunc(new Map(rObj));
        } else {
            const { childrenData, isChildStatic, belongingKey } = props;
            let childrenDataObject = childrenData.toObject();
            let childItemDataObject = childrenDataObject[belongingKey].toObject();
            let _childrenListItemVisibilityList = null;
            if (isChildStatic === true) {
                let childrenListItemVisibilityList = childItemDataObject.visibilities;
                let childrenListItemVisibilityArray = childrenListItemVisibilityList.toArray()

                let initialVal = childrenListItemVisibilityArray[index]
                childrenListItemVisibilityArray[index] = !initialVal;
                _childrenListItemVisibilityList = new List(childrenListItemVisibilityArray)
            } else { //isChildDynamic
                let childrenListItemVisibilityArray = childItemDataObject.visibilities;
                let initialVal = childrenListItemVisibilityArray[index]
                childrenListItemVisibilityArray[index] = !initialVal;
                _childrenListItemVisibilityList = childrenListItemVisibilityArray
            }
            /*Ortak Kısım*/
            let _childItemDataObject = {
                ...childItemDataObject,
                "visibilities": _childrenListItemVisibilityList
            }
            let newChildrenMap = new Map(childrenData).set(belongingKey, new Map(_childItemDataObject))
            props.setChildrenList(newChildrenMap)
        }
    }

    const checkDataItemVisibility = () => {
        const { id, newDataVisibilities, childrenData, isChildStatic, belongingKey } = props;
        if (!props.isChild) {
            return newDataVisibilities.get(id);
        } else {
            if (isChildStatic === true) {
                return childrenData.get(belongingKey).get("visibilities").get(id);
            } else {
                return childrenData.get(belongingKey).get("visibilities")[id];//dynamic data'da visibilites arr type
            }
        }
    }

    const setBounds = () => {
        const { setBoundsDelegateFnc } = props;
        let el = document.getElementById(props.dataName);
        if (el !== undefined && el !== null) {
            setBoundsDelegateFnc(JSON.parse(el.getAttribute("value")))
        }
    }
    const { dataName, id, newDataVisibilities, newSetDataListVisibilities } = props;
    return (
        <div className="dataset_item">
            <Grid container className={classes.containerGrid}>
                <Grid item xs={10} >
                    <ButtonBase className={classes.buttonBase} onClick={() => setBounds()}>
                        <span className="btn_txt">{dataName}</span>
                    </ButtonBase>
                </Grid>

                <Grid item xs={2} className={classes.visibilityButtonContainer}>
                    <Button className={classes.visibilityButton} onClick={() => handleUpdate(id, newDataVisibilities, newSetDataListVisibilities)}>
                        <a className="visibility_symbol">
                            <FontAwesomeIcon style={checkDataItemVisibility() ? { color: "black" } : { color: "red" }} className="eye_icon" size="lg" icon={checkDataItemVisibility() ? faEye : faEyeSlash} />
                        </a>
                    </Button>
                </Grid>
            </Grid>
            {/* <Button className="dataset_item" onClick={() => handleUpdate(id, newDataVisibilities, newSetDataListVisibilities)}>
                <span className="btn_txt">{dataName}</span>

            </Button>
            <Button className="dataset_item" onClick={() => handleUpdate(id, newDataVisibilities, newSetDataListVisibilities)}>
                <a className="visibility_symbol">
                    <FontAwesomeIcon style={checkDataItemVisibility() ? { color: "black" } : { color: "red" }} className="eye_icon" size="lg" icon={checkDataItemVisibility() ? faEye : faEyeSlash} />
                </a>
            </Button> */}
        </div>
    );
}